import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryClient';
import {
  InventoryFilters,
  StorageSummaryFilters,
  InventoryTransactionFilters,
} from '../types';
import { inventoryService } from '../services/inventoryService';

// Custom hooks
export const useInventory = (filters?: InventoryFilters) => {
  return useQuery({
    queryKey: queryKeys.inventory.list(filters),
    queryFn: () => inventoryService.getInventory(filters),
    staleTime: 0, // Always fetch fresh data
    refetchOnMount: true,
    placeholderData: (previousData) => previousData,
  });
};

export const useClientInventory = (clientId: number, filters?: Omit<InventoryFilters, 'clientId'>) => {
  return useQuery({
    queryKey: queryKeys.inventory.client(clientId, filters),
    queryFn: () => inventoryService.getClientInventory(clientId, filters),
    enabled: !!clientId && clientId > 0,
    staleTime: 0, // Always fetch fresh data
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
};

export const useStorageSummary = (filters: StorageSummaryFilters | null) => {
  return useQuery({
    queryKey: queryKeys.inventory.storage(filters),
    queryFn: () => inventoryService.getStorageSummary(filters!),
    enabled: !!filters && !!filters.clientId && !!filters.productDescription,
    staleTime: 0, // Always fetch fresh data
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
};

export const useInventoryTransactions = (filters?: InventoryTransactionFilters, enabled: boolean = true) => {
  return useQuery({
    queryKey: queryKeys.inventory.transactions(filters),
    queryFn: () => inventoryService.getTransactions(filters),
    enabled,
    refetchOnMount: 'always',
    staleTime: 0,
  });
};
